function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
import withEvents from "../../lib/withEvents";
import mapEvents from "./events";
import options from "./options";
import withWatchers from "./mixins/withWatchers";
import withPrivateMethods from "./mixins/withPrivateMethods";
import withAsyncActions from "./mixins/withAsyncActions";
export default {
  name: "GlMap",
  mixins: [withWatchers, withAsyncActions, withPrivateMethods, withEvents],
  props: _objectSpread({
    mapboxGl: {
      type: Object,
      default: null
    }
  }, options),
  provide: function provide() {
    var self = this;
    return {
      get mapbox() {
        return self.mapbox;
      },

      get map() {
        return self.map;
      },

      get actions() {
        return self.actions;
      }

    };
  },
  data: function data() {
    return {
      initial: true,
      initialized: false
    };
  },
  computed: {
    loaded: function loaded() {
      return this.map ? this.map.loaded() : false;
    },
    version: function version() {
      return this.map ? this.map.version : null;
    },
    // TODO: make 'bounds' synced prop
    bounds: function bounds() {
      return this.map ? this.map.getBounds() : null;
    },
    isStyleLoaded: function isStyleLoaded() {
      return this.map ? this.map.isStyleLoaded() : false;
    },
    areTilesLoaded: function areTilesLoaded() {
      return this.map ? this.map.areTilesLoaded() : false;
    },
    isMoving: function isMoving() {
      return this.map ? this.map.isMoving() : false;
    },
    canvas: function canvas() {
      return this.map ? this.map.getCanvas() : null;
    },
    canvasContainer: function canvasContainer() {
      return this.map ? this.map.getCanvasContainer() : null;
    },
    images: function images() {
      return this.map ? this.map.listImages() : null;
    }
  },
  created: function created() {
    this.map = null;
    this.propsIsUpdating = {};
    this.mapboxPromise = this.mapboxGl ? Promise.resolve(this.mapboxGl) : import("mapbox-gl");
  },
  mounted: function mounted() {
    var _this = this;

    this.$_loadMap().then(function (map) {
      _this.map = map;

      if (_this.RTLTextPluginUrl !== undefined) {
        _this.mapbox.setRTLTextPlugin(_this.RTLTextPluginUrl, _this.$_RTLTextPluginError);
      }

      var eventNames = Object.keys(mapEvents);

      _this.$_bindMapEvents(eventNames);

      _this.$_registerAsyncActions(map);

      _this.$_bindPropsUpdateEvents();

      _this.initial = false;
      _this.initialized = true;

      _this.$emit("load", {
        map: map,
        component: _this
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    this.$nextTick(function () {
      if (_this2.map) _this2.map.remove();
    });
  }
};